import type { ClickOffsetPct, ClickXY, ElementRect } from '@pinmerge/shared';
import type { LocalComment } from '../storage';

// Back-fills a click_offset_pct for legacy server rows (pre-0008) using the
// stored click_xy and element_rect, both of which are in document coords from
// capture time. Returns null when either is missing or the rect is degenerate.
export function deriveOffsetPct(
  click: ClickXY | null,
  rect: ElementRect | null,
): ClickOffsetPct | null {
  if (!click || !rect) return null;
  if (rect.w <= 0 || rect.h <= 0) return null;
  const x = (click.x - rect.x) / rect.w;
  const y = (click.y - rect.y) / rect.h;
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  return {
    x: Math.max(0, Math.min(1, x)),
    y: Math.max(0, Math.min(1, y)),
  };
}

export function isOwnComment(c: LocalComment, ownToken: string): boolean {
  // Server-fetched rows carry an explicit `mine` flag (computed server-side
  // from the caller's creator_token — other reviewers' raw tokens are no longer
  // sent to the client).
  if (c.mine !== undefined) return c.mine;
  // Local-only entries created in this browser, or legacy cached rows from
  // before `mine` existed: a stored creatorToken that matches is ours; an
  // absent one predates the multi-reviewer feature → treat as ours.
  if (!c.creatorToken) return true;
  return c.creatorToken === ownToken;
}
